import assetPositionsFactory from '../positions/asset-positions-factory';

export default assetPositionsFactory({
  assetCategory: 'equities',
  positionsTo: 1,
});
